export default __webpack_public_path__ + "static/media/az_new_paper.e5b8b563.png";